// Generated by purs version 0.14.4
import * as $foreign from "./foreign.js";
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Apply from "../Control.Apply/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect_Aff from "../Effect.Aff/index.js";
import * as JQuery from "../JQuery/index.js";
var triggerDocument = function (eventType) {
    return function (eventData) {
        return function __do() {
            var d = $foreign.getDocument();
            return $foreign.trigger(eventType)(eventData)(d)();
        };
    };
};
var show = function (el) {
    return JQuery.removeClass("hide")(el);
};
var post = function (url) {
    return function (req) {
        return Effect_Aff.makeAff(function (callback) {
            var resolve = function ($0) {
                return callback(Data_Either.Right.create($0));
            };
            var reject = function ($1) {
                return callback(Data_Either.Left.create($1));
            };
            return Control_Apply.applySecond(Effect.applyEffect)($foreign.postImpl(reject)(resolve)(url)(req))(Control_Applicative.pure(Effect.applicativeEffect)(Effect_Aff.nonCanceler));
        });
    };
};
var hide = function (el) {
    return JQuery.addClass("hide")(el);
};
var exists = function (el) {
    return $foreign.length(el) > 0;
};
export {
    getAttr,
    postImpl,
    parents,
    length,
    toArray,
    getDocument,
    trigger,
    getData,
    setData,
    addBack,
    filter,
    one,
    wrapNode,
    removeAttr,
    empty,
    selector,
    addTestLoadedMarker,
    logErrorOnElement,
    focus
} from "./foreign.js";
export {
    post,
    exists,
    show,
    hide,
    triggerDocument
};
//# sourceMappingURL=index.js.map
